import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { waLink, WA_DEFAULT_MSG } from "@/lib/whatsapp";

export const FloatingWhatsApp = () => (
  <a
    href={waLink(WA_DEFAULT_MSG)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-btn"
    aria-label="Chat with Rajkiran Wealth on WhatsApp"
    className="wa-pulse fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-110"
  >
    <WhatsAppIcon className="h-7 w-7" />
  </a>
);
